import {
  BillSwitchEventPayload as BillSwitchEventPayloadWeb,
  ErrorEventPayload as ErrorEventPayloadWeb,
  ExternalAccountConnectedEventPayload as ExternalAccountConnectedPayloadWeb,
  LoginEventPayload as LoginEventPayloadWeb,
} from '@pinwheel/react-modal';
import {
  BillSwitchPayload,
  ErrorEventPayload,
  ExternalAccountConnectedPayload,
  LoginEventPayload,
} from '@pinwheel/react-native-pinwheel/src/client-events/registry/v2.3';
import { Maybe } from 'graphql/jsutils/Maybe';

export const isPinwheelErrorPayload = (
  obj?: object,
): obj is ErrorEventPayloadWeb | ErrorEventPayload => {
  if (!obj) {
    return false;
  }
  return (
    'type' in obj && 'code' in obj && 'message' in obj && 'pendingRetry' in obj
  );
};

export const asPinwheelErrorPayload = (
  obj?: object,
): Maybe<ErrorEventPayloadWeb | ErrorEventPayload> => {
  if (isPinwheelErrorPayload(obj)) {
    return obj;
  }

  console.error('Received invalid Pinwheel Error Payload object', obj);
  return null;
};

export const isPinwheelExternalAccountConnectedPayload = (
  obj?: object,
): obj is
  | ExternalAccountConnectedPayloadWeb
  | ExternalAccountConnectedPayload => {
  if (!obj) {
    return false;
  }

  return 'institutionName' in obj && 'accountName' in obj;
};
export const asPinwheelExternalAccountConnectedPayload = (
  obj?: object,
): Maybe<
  ExternalAccountConnectedPayloadWeb | ExternalAccountConnectedPayload
> => {
  if (isPinwheelExternalAccountConnectedPayload(obj)) {
    return obj;
  }

  console.error(
    'Received invalid Pinwheel External Account Connected Payload object',
    obj,
  );
  return null;
};

export const isPinwheelLoginSuccessPayload = (
  obj?: object,
): obj is LoginEventPayloadWeb | LoginEventPayload => {
  if (!obj) {
    return false;
  }

  return 'platformId' in obj && 'accountId' in obj;
};
export const asPinwheelLoginSuccessPayload = (
  obj?: object,
): Maybe<LoginEventPayloadWeb | LoginEventPayload> => {
  if (isPinwheelLoginSuccessPayload(obj)) {
    return obj;
  }

  console.error('Received invalid Pinwheel Login Success Payload object', obj);
  return null;
};

export const isPinwheelBillSwitchSuccessPayload = (
  obj?: object,
): obj is BillSwitchEventPayloadWeb | BillSwitchPayload => {
  if (!obj) {
    return false;
  }
  return (
    'platformId' in obj &&
    'platformName' in obj &&
    'isIntegratedSwitch' in obj &&
    'frequency' in obj &&
    'nextPaymentDate' in obj &&
    'amountCents' in obj
  );
};

export const asPinwheelBillSwitchSuccessPayload = (
  obj?: object,
): Maybe<BillSwitchEventPayloadWeb | BillSwitchPayload> => {
  if (!obj) {
    return null;
  }

  if (isPinwheelBillSwitchSuccessPayload(obj)) {
    return obj;
  }

  console.error(
    'Received invalid Pinwheel Bill Switch Success Payload object',
    obj,
  );
  return null;
};
